export const systemConfig = {
  unauthorizedRedirectTo: '401',
  authServiceKey: 'init',
};
